import React, { Component, PropTypes } from 'react';
import { merge, unionBy } from 'lodash';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import axios from 'axios';
import baseUrl from '../../utils/baseUrl';
import metaDesc from '../../utils/meta';
import { genericRoute } from '../../routes';

import Countdown from '../../components/countdown/countdown';
import LiveJudgingCase from './liveJudgingCase';
import Spinner from '../../components/svg/spinner';
import Onboarding from './onboarding';

import connect from '../../utils/connect';

import * as helper from './livehelper';

import css from './livejudging.scss';

class LiveJudging extends Component {

	constructor(props) {
		super();

		this.minHeight = 0;
		this.metaDesc = '';

		this.state = {
			nextFOTD: 0,
			initialized: 0,
			cases: [],
			meta: [],
		};
	}

	componentWillMount() {
		this.mounted = true;

		axios.get(baseUrl + '/api/live/cases')
		.then((res) => {
			if (res.data && res.data.cases) {
				this.scheduleUpdate();

				this.setState({
					...this.state,
					initialized: 1,
					nextFOTD: (res.data.nextFOTD) - (new Date().getTime() / 1000),
					cases: res.data.cases,
					meta: res.data.meta,
				});
			}
		})
		.catch((res) => {
			this.setState({
				...this.state,
				initialized: 2,
			});
		});
	}

	componentWillReceiveProps(nextProps) {}

	componentWillUpdate() {}

	componentWillUnmount() {
		this.mounted = false;
		this.cancelScheduleUpdate();
	}

	render() {
		if (!this.state.initialized) {
			return this.renderWaiting();
		}

		let bp = helper.getBreakpoint(this.props.browser);
		let elDims = helper.getElementDimensions(bp);
		let colNumber = helper.getColNumber(bp);

		let highestRankAbove50 = ((cases) => {
			let curHigh = 0;
			for (let i = 0; i < cases.length; i++) {
				if (cases[i].points > 50 && cases[i].rank > curHigh) {
					curHigh = cases[i].rank;
				}
			}

			return curHigh;
		})(this.state.cases);

		let rankColOffset = helper.getRankColOffset(this.state.cases.length, highestRankAbove50, colNumber);
		let rows = helper.getRow(this.state.cases.length, colNumber, rankColOffset) + 1;
		let splitRows = helper.getRow(highestRankAbove50 + 1, colNumber, rankColOffset);
		let splitterOffset = helper.getSplitterOffset(bp);
		let splitOffsetTop = (elDims.h * splitRows);
		let lowerEntriesOffsetTop = (elDims.h * (splitRows - 1));
		let height = (elDims.h * rows) + (highestRankAbove50 < this.state.cases.length ? splitterOffset : 0);

		let isMobile = (bp === helper.BP_MOBILE_LARGE || bp === helper.BP_MOBILE_SMALL);

		if (isMobile) {
			splitOffsetTop += 70;
			lowerEntriesOffsetTop += 70;
			height += 70;
		}

		if (highestRankAbove50 === 0 && this.state.cases.length) {
			highestRankAbove50 = this.state.cases.length;
		}

		if (this.state.meta && this.state.meta.description !== this.metaDesc) {
			metaDesc(this.state.meta.description);
			this.metaDesc = this.state.meta.description;
		}

		return (
			<div className='live-judging'>
				{this.state.meta && this.state.meta.title && (
				<Helmet title={this.state.meta.title} />
				) || (
				<Helmet title={`The FWA - Live Judging`} />
				)}

				<Onboarding ref='onboard' name='intro' browser={this.props.browser} />

				<div className='live-judging__head span14'>
					{(isMobile) && (
						<Countdown timeLeft={this.state.nextFOTD} />
					)}
					<div className='live-judging__head__aside span4 span6-tablet span14-mobile'>
						Current Leader
					</div>
					<div className='live-judging__head__content span10 span8-tablet hide-mobile'>
						<div className='live-judging__head__content__buttons'>
							<a
								className='button'
								onClick={(e) => {
									e.preventDefault();
									this.refs.onboard.toggle(false);
								}
							}>
								Learn more
							</a>
							<Link to={genericRoute(false, 'submit/project')} className='button button--dark button--go'>Submit your project</Link>
						</div>

						<div className='live-judging__head__content__announcement'>
							<span className='live-judging__head__content__announcement__text'>Next FWA of the Day announced in:</span>
							<div className='live-judging__head__content__announcement__grid'>
								<div className='live-judging__head__content__announcement__grid__item'>Hours</div>
								<div className='live-judging__head__content__announcement__grid__item'>Minutes</div>
								<div className='live-judging__head__content__announcement__grid__item'>Seconds</div>
							</div>

							{(!isMobile) && (
								<Countdown timeLeft={this.state.nextFOTD} />
							)}
						</div>
					</div>
					<div className='cf'></div>
				</div>

				<div className='live-judging__grid' style={{ height: height + 'px' }}>
					{this.state.cases.map((item, i) => {
						return (
							<LiveJudgingCase key={item.id} rank={item.rank} divideAt={highestRankAbove50} item={item} browser={this.props.browser} isTop={true} />
						);
					})}

					<div className='live-judging__grid__aside span2 span6-mobile' style={{ top: elDims.h + 'px' }}>
						{(highestRankAbove50 >= 4) && (
							<div className='live-judging__grid__aside__top'>
								<div>Top</div>
								<div>entries</div>
							</div>
						)}

						{(highestRankAbove50 < this.state.cases.length) && (
							<div className='live-judging__grid__aside__lower' style={{ top: lowerEntriesOffsetTop + 'px' }}>
								<div>Low<span className='live-judging__grid__aside__lower__unnecessary'>er</span></div>
								<div>entries</div>
							</div>
						)}
					</div>

					{(!!highestRankAbove50 && highestRankAbove50 < this.state.cases.length) && (
						<div className='live-judging__grid__50split pixel-pattern-overlay pixel-pattern-overlay--01 span12 span14-mobile' style={{ top: splitOffsetTop + 'px' }}>50 pts—</div>
					)}
				</div>
			</div>
		);
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	scheduleUpdate(grace = 10000) {
		//console.debug('Timer scheduled in ' + grace + 'ms');
		this.updateTimer = setTimeout(() => {
			axios(baseUrl + '/api/live/updates')
			.then((res) => {
				if (this.mounted && res.data.cases) {
					this.grace = 10000;
					this.sortByUpdatedScore(this.state.cases, res.data.cases);
				}
			})
			.catch((res) => {
				// fail
				setTimeout(() => {
					this.scheduleUpdate();
				}, 10000);
			});
		}, grace);
	}

	cancelScheduleUpdate() {
		clearTimeout(this.updateTimer);
		clearTimeout(this.sortTimer);
	}

	getUpdateActions(oldCases, newCases) {
		let actions = [];
		let _union = unionBy(oldCases, newCases, (item) => item.id);

		let FOUND_OLD = 'FOUND_OLD';
		let FOUND_NEW = 'FOUND_NEW';
		let NOT_FOUND_OLD = 'NOT_FOUND_OLD';
		let NOT_FOUND_NEW = 'NOT_FOUND_NEW';

		//console.debug(oldCases, newCases, _union);

		for (let i = 0; i < _union.length; i++) {
			let oldStatus = NOT_FOUND_OLD;
			for (var k = 0; k < oldCases.length; k++) {
				if (oldCases[k].id === _union[i].id) {
					oldStatus = FOUND_OLD;
				}
			}

			let newStatus = NOT_FOUND_NEW;
			for (var k = 0; k < newCases.length; k++) {
				if (newCases[k].id === _union[i].id) {
					newStatus = FOUND_NEW;
				}
			}

			// console.debug(oldStatus, newStatus);

			if (oldStatus === NOT_FOUND_OLD && newStatus === FOUND_NEW) {
				actions.push({
					action: 'ADD',
					id: _union[i].id,
				});
			} else if (oldStatus === FOUND_OLD && newStatus === NOT_FOUND_NEW) {
				actions.push({
					action: 'REMOVE',
					id: _union[i].id,
				});
			}
		}

		//console.debug('ACTIONS:', actions);

		return actions;
	}

	runUpdateActions(actions, oldCases) {
		let _newCasesCache = [];
		let _oldCases = [...oldCases];

		let actionPromise = new Promise((resolve, reject) => {
			let AJAXIsDonePromise = new Promise((aResolve, aReject) => {
				let ajax = false;
				for (let i = 0; i < actions.length; i++) {
					if (actions[i].action === 'ADD') {
						ajax = true;
					}
				}

				if (ajax) {
					// console.debug('NEED NEW CASES - FETCHING');
					axios.get(baseUrl + '/api/live/cases')
					.then((res) => {
						// console.debug('FETCH COMPLETE');
						if (res.data.cases && res.data.cases.length) {
							_newCasesCache = res.data.cases;
						}

						aResolve();
					})
					.catch((res) => {
						// console.debug('FETCH FAILED');
						aResolve();
					});
				} else {
					// console.debug('FETCH NOT NEEDED');
					aResolve();
				}
			});

			AJAXIsDonePromise.then(() => {
				for (let i = 0; i < actions.length; i++) {
					if (actions[i].action === 'ADD') {
						// find new case
						// console.debug('ADDING CASE');
						for (let k = 0; k < _newCasesCache.length; k++) {
							// console.debug(`CHECKING (${k})`);
							if (_newCasesCache[k].id === actions[i].id) {
								// console.debug(`CASE FOUND ${actions[i].id}: ADDING`);
								let caseBeingAdded = _newCasesCache[k];
								caseBeingAdded.rank = oldCases.length + 1;
								_oldCases.push(caseBeingAdded);
								break; // 1 thing pr. action
							}
						}
					} else if (actions[i].action === 'REMOVE') {
						// console.debug('REMOVING CASE');
						for (let k = 0; k < _oldCases.length; k++) {
							if (_oldCases[k].id === actions[i].id) {
								// console.debug(`CASE FOUND ${actions[i].id} - ${k}: REMOVING`);
								//console.debug([..._oldCases]);
								_oldCases.splice(k, 1);
								//console.debug([..._oldCases]);
								break; // 1 thing pr. action
							}
						}
					}
				}

				// console.debug('DONE RUNNING UPDATES');
				// console.debug([..._oldCases]);

				resolve(_oldCases);
			})
			.catch((e) => {
				// console.debug(e);
				resolve(_oldCases);
			});
		});

		return actionPromise;
	}

	sortByUpdatedScore(oldCases, newCases) {
		//console.debug('sortScores');
		let updateActions = this.getUpdateActions(oldCases, newCases);
		let updateActionPromise = Promise.resolve(oldCases);
		if (updateActions.length) {
			// console.debug('MISMATCH - RUNNING UPDATE ACTIONS');
			updateActionPromise = this.runUpdateActions(updateActions, oldCases);
		}

		// console.debug(updateActionPromise);
		updateActionPromise.then((_oldCases) => {

			// console.debug('PROMISES RESOLVED:');
			// console.debug(_oldCases);

			for (let i = 0; i < newCases.length; i++) {
				let newCase = newCases[i];

				for (let i = 0; i < _oldCases.length; i++) {
					let oldCase = _oldCases[i];

					if (oldCase.id === newCase.id && newCase.rank < oldCase.rank) {

						return this.promoteCase(oldCase, newCase, _oldCases, newCases);
					} else if (
						oldCase.id === newCase.id &&
						(newCase.rank !== oldCase.rank || newCase.voteCount !== oldCase.voteCount || newCase.points !== oldCase.points)
					) {
						return this.promoteCase(oldCase, newCase, _oldCases, newCases);
					}
				}
			}

			// in case of removal
			if (_oldCases.length !== this.state.cases.length) {
				return this.fixCases(_oldCases, newCases);
			}

			this.scheduleUpdate(this.grace);
		})
		.catch((e) => {
			// console.debug(e);
		});
	}

	fixCases(allCaseItems, allNewCases) {
		//console.debug(`IN ${helper.ANIMATION_DURATION}ms SORT AGAIN`);
		this.sortTimer = setTimeout(() => {
			this.grace = (this.grace > helper.ANIMATION_DURATION) ? this.grace - helper.ANIMATION_DURATION : 0;
			this.sortByUpdatedScore(allCaseItems, allNewCases);
		}, helper.ANIMATION_DURATION + 500);

		// console.debug('SETTING STATE:', allCaseItems);

		this.setState({
			...this.state,
			cases: [...allCaseItems],
		});

	}

	promoteCase(caseItem, newCase, allCaseItems, allNewCases) {
		let promoteFromRank = caseItem.rank;
		let promoteToRank = newCase.rank;

		let allNewCasesById = ((newCases) => {
			let formattedObj = {};
			for (var i = 0; i < newCases.length; i++) {
				formattedObj[newCases[i].id] = newCases[i];
			}

			return formattedObj;
		})(allNewCases);

		// for all cases between the rank we are promoting to
		// and the rank we are promoting from.. set rank--
		for (var i = 0; i < allCaseItems.length; i++) {
			if (allCaseItems[i].rank <= promoteFromRank && allCaseItems[i].rank >= promoteToRank) {
				let newRank = allCaseItems[i].rank + 1;
				allCaseItems[i] = merge(allCaseItems[i], allNewCasesById[allCaseItems[i].id]);
				allCaseItems[i].rank = newRank;
			}
		}

		// find case and set to new rank
		for (var i = 0; i < allCaseItems.length; i++) {
			if (allCaseItems[i].id === caseItem.id) {
				allCaseItems[i] = merge(allCaseItems[i], newCase);
			}
		}

		//console.debug(`IN ${helper.ANIMATION_DURATION}ms SORT AGAIN`);
		this.sortTimer = setTimeout(() => {
			this.grace = (this.grace > helper.ANIMATION_DURATION) ? this.grace - helper.ANIMATION_DURATION : 0;
			this.sortByUpdatedScore(allCaseItems, allNewCases);
		}, helper.ANIMATION_DURATION + 500);

		// console.debug('SETTING STATE:', allCaseItems);

		this.setState({
			...this.state,
			cases: [...allCaseItems],
		});
	}
}

export default connect(LiveJudging);



/** WEBPACK FOOTER **
 ** ./frontend/containers/livejudging/livejudging.js
 **/